(() => {
  const STORAGE_KEY = 'spzdbl_error_log_v1';
  const MAX_ENTRIES = 80;

  const safeString = (value) => {
    if (value instanceof Error) return `${value.name}: ${value.message}\n${value.stack || ''}`.trim();
    if (typeof value === 'string') return value;
    try {
      return JSON.stringify(value);
    } catch (error) {
      return String(value);
    }
  };

  const readLog = () => {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      return [];
    }
  };

  const writeLog = (entries) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(-MAX_ENTRIES)));
    } catch (error) {
      // Storage can be blocked in some browser modes. The shop should keep working.
    }
  };

  const addEntry = (type, message, details = {}) => {
    const entry = {
      time: new Date().toISOString(),
      type,
      message: safeString(message),
      url: window.location.href,
      userAgent: navigator.userAgent,
      details,
    };

    writeLog([...readLog(), entry]);
    return entry;
  };

  window.spzdblLogError = addEntry;
  window.spzdblGetErrorLog = readLog;
  window.spzdblClearErrorLog = () => writeLog([]);

  window.addEventListener('error', (event) => {
    addEntry('window.error', event.message, {
      source: event.filename,
      line: event.lineno,
      column: event.colno,
      error: safeString(event.error),
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    addEntry('unhandledrejection', event.reason || 'Unhandled promise rejection');
  });

  ['error', 'warn'].forEach((method) => {
    const original = console[method];
    console[method] = (...args) => {
      addEntry(`console.${method}`, args.map(safeString).join(' '));
      original.apply(console, args);
    };
  });

  const shouldShowPanel = new URLSearchParams(window.location.search).get('spzdbl_debug') === '1';
  if (!shouldShowPanel) return;

  const panel = document.createElement('div');
  panel.style.cssText = [
    'position:fixed',
    'right:12px',
    'bottom:12px',
    'z-index:2147483647',
    'width:min(520px,calc(100vw - 24px))',
    'max-height:55vh',
    'overflow:auto',
    'background:#111',
    'color:#fff',
    'font:12px/1.4 monospace',
    'border:2px solid #ffc201',
    'border-radius:8px',
    'box-shadow:0 8px 32px rgb(0 0 0 / 0.35)',
    'padding:12px',
  ].join(';');

  const render = () => {
    const entries = readLog().slice().reverse();
    panel.innerHTML = `
      <div style="display:flex;gap:8px;align-items:center;justify-content:space-between;margin-bottom:8px;">
        <strong>SPZDBL error log (${entries.length})</strong>
        <span>
          <button type="button" data-spzdbl-copy-log>Copy</button>
          <button type="button" data-spzdbl-clear-log>Clear</button>
        </span>
      </div>
      <pre style="white-space:pre-wrap;margin:0;">${entries
        .map((entry) => `${entry.time} [${entry.type}]\n${entry.message}\n${entry.url}`)
        .join('\n\n---\n\n') || 'No logged browser errors yet.'}</pre>
    `;
  };

  panel.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (target?.matches('[data-spzdbl-clear-log]')) {
      window.spzdblClearErrorLog();
      render();
    }
    if (target?.matches('[data-spzdbl-copy-log]')) {
      await navigator.clipboard?.writeText(JSON.stringify(readLog(), null, 2));
      target.textContent = 'Copied';
      window.setTimeout(() => {
        target.textContent = 'Copy';
      }, 1200);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.body.appendChild(panel);
    render();
  });
})();
